<template>
  <li v-if="!childrenLinks && isHeader" :class="{ headerLink: true, [className]: true }">
    <router-link :to="link" class="sidebar-link">
      <span class="icon">
        <inline-svg v-if="iconImg" :src="require('@/assets/' + iconImg + '')" fill="currentColor"></inline-svg>
        <i v-else :class="fullIconName"></i>
      </span>
      
      <span class="link-title">{{ header }}</span>
      
      <sup v-if="label" :class="'text-' + labelColor" class="headerLabel">{{ label }}</sup>
      <span v-if="badge" class="badge rounded-pill bg-danger">{{ badge }}</span>
    </router-link>
  </li>

  <li v-else-if="childrenLinks" :class="{ headerLink: true, open: isParentActive, [className]: true }">
    <div @click="toggleCollapse">
      <a class="d-flex sidebar-link" :class="{ 'parent-active': isParentActive }">
        <span class="icon">
          <inline-svg v-if="iconImg" :src="require('@/assets/' + iconImg + '')" fill="currentColor"></inline-svg>
          <i v-else :class="fullIconName"></i>
        </span>
        
        <span class="link-title">{{ header }}</span>
        
        <sup v-if="label" :class="'text-' + labelColor" class="ms-1 headerLabel">{{ label }}</sup>
        <div :class="{ caretWrapper: true, carretActive: isOpen }">
          <i class="fa fa-angle-right" />
        </div>
      </a>
    </div>
    <b-collapse :id="'collapse' + index" :visible="isOpen">
      <ul class="sub-menu">
        <NavLink
          v-for="childrenLink in childrenLinks"
          :activeItem="activeItem"
          :header="childrenLink.header"
          :index="childrenLink.index"
          :link="childrenLink.link"
          :childrenLinks="childrenLink.childrenLinks"
          :key="childrenLink.link"
        />
      </ul>
    </b-collapse>
  </li>

  <li v-else class="sub-item">
    <router-link :to="index !== 'menu' && link" class="sub-link">
      <span class="link-title">{{ header }}</span>
      <sup v-if="label" :class="'text-' + labelColor" class="headerLabel">{{ label }}</sup>
    </router-link>
  </li>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'NavLink',
  props: {
    badge: { type: String, default: '' },
    header: { type: String, default: '' },
    iconName: { type: String, default: '' },
    iconImg: { type: String, default: '' },
    headerLink: { type: String, default: '' },
    link: { type: String, default: '' },
    childrenLinks: { type: Array, default: null },
    className: { type: String, default: '' },
    isHeader: { type: Boolean, default: false },
    deep: { type: Number, default: 0 },
    activeItem: { type: String, default: '' },
    label: { type: String },
    labelColor: { type: String, default: 'warning' },
    index: { type: String }
  },
  data() {
    return {
      isCollapsedByUser: false,
    };
  },
  watch: {
    // Reset status collapse kustom ketika terjadi perpindahan rute/halaman
    $route() {
      this.isCollapsedByUser = false;
    }
  },
  methods: {
    ...mapActions('layout', ['changeSidebarActive']),
    toggleCollapse() {
      if (this.isParentActive) {
        this.isCollapsedByUser = !this.isCollapsedByUser;
      } else {
        this.changeSidebarActive(this.index);
        this.isCollapsedByUser = false;
      }
    },
  },
  computed: {
    fullIconName() {
      return `fi ${this.iconName}`;
    },
    // Memeriksa apakah salah satu anak dari menu ini sedang aktif berdasarkan rute saat ini
    isChildRouteActive() {
      if (!this.childrenLinks) return false;
      return this.childrenLinks.some(child => child.link && this.$route.path.startsWith(child.link));
    },
    // Parent dianggap aktif HANYA jika rute anak sedang aktif atau index Vuex cocok
    isParentActive() {
      return this.isChildRouteActive || (this.activeItem && this.activeItem.includes(this.index));
    },
    isOpen() {
      if (this.isCollapsedByUser) return false;
      return this.isParentActive;
    }
  },
};
</script>

<style src="./NavLink.scss" lang="scss" scoped />